<template>
  <div
    class="fixed inset-0 overflow-hidden z-10 bg-black bg-opacity-60"
    @click="$emit('closeModal')"
  >
    <div
      :class="[
        isContentWriter ? 'max-w-sm md:max-w-lg lg:max-w-2xl' : 'max-w-sm',
        'fixed inset-y-0 right-0 p-4 bg-white w-full overflow-y-scroll',
      ]"
      @click.stop=""
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlideOverSideBar",
  emits: ["closeModal"],
  props: {
    isContentWriter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
